module.exports = __webpack_public_path__ + "img/Réalisation portail avec découpe laser.daf02d40.jpg";